import { Api } from '../../../services/interceptor';
import { QUERY_KEY } from '../../../services/queryEndPoint';
import type { PlayerV2UpdateBody } from '../types/playerV2.d';

export async function updatePlayerProfileV2(body: PlayerV2UpdateBody): Promise<void> {
  await Api.put(QUERY_KEY.updatePlayerV2, body);
}
